import {CONFIG} from "../../config";
import {facet_replacement} from "./facet_replacements";

const getFacetGroupTitle = (name) => {
    return facet_replacement(name, CONFIG.facetsGroupTitleReplacements);
}

export default getFacetGroupTitle;